import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { FilterOptionViewModel } from 'autogen/swagger/all';
import { Sorting } from 'autogen/translation-keys/trans-website-filter';
import { FilterMenuFooterSimple } from '../../FilterMenu/components/FilterMenuFooter';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import SortingFilterOption from './SortingFilterOption';

export const sortingFilterMenuId = 'sorting-menu';

const SortingFilterMenu = ({ model: options }: { model: FilterOptionViewModel[] }) => {
    const filterMenuId = sortingFilterMenuId;
    const { t } = useTranslation();

    return (
        <FilterMenuDrawer id={filterMenuId} headline={t(Sorting)} footerRenderer={() => <FilterMenuFooterSimple />}>
            {options.map((option) => (
                <SortingFilterOption key={option.displayName} model={option} />
            ))}
        </FilterMenuDrawer>
    );
};

export default memo(SortingFilterMenu);
